import React from "react";
import styled from "styled-components";
import { palette, size } from "styled-theme";
import { mobileBreakPoint } from "../constants";

const LoanDetailItemWrapper = styled.li`
  list-style: none;
  text-align: center;
  margin-bottom: 20px;
  
  .title {
    margin-bottom: 5px;
  }
  
  .value {
    font-size: 18px;
    line-height: 1.17;
    color: ${palette("thankYou", 1)};
  }
  
  @media only screen and (min-width: ${size(mobileBreakPoint)}) {
    padding-left: 20px;
    padding-right: 20px;
    &:not(:last-child) {
      border-right: 1px solid ${palette("thankYou", 2)};
    }
    
    .title, .value {
      white-space: nowrap;
    }
  }
`;

export const LoanDetailItem = ({title, children }) => (
  <LoanDetailItemWrapper>
    <p className="title">{title}</p>
    <p className="value">{children}</p>
  </LoanDetailItemWrapper>
);